import { render, staticRenderFns } from "./OptionDiagAnswerInput.vue?vue&type=template&id=87fefd7e&scoped=true&"
import script from "./OptionDiagAnswerInput.vue?vue&type=script&lang=js&"
export * from "./OptionDiagAnswerInput.vue?vue&type=script&lang=js&"
import style0 from "./OptionDiagAnswerInput.vue?vue&type=style&index=0&id=87fefd7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87fefd7e",
  null
  
)

export default component.exports